import {Component,HostListener,OnInit} from '@angular/core';
import { ConnectionService } from 'ng-connection-service';
import { Router, ActivatedRoute } from '@angular/router';
import { MenuitemsService} from './modules/dashboard/menuitems/menuitems.service'
// import {TranslateService} from '@ngx-translate/core';
import {AppService} from './app.service'
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'VidhyaDhan';
  new_version_number = null;
  curent_version_number = null;
  showButton: boolean = false;

  constructor(private connectionService: ConnectionService,
    private router: Router,
    private appService : AppService,
    private menuitemsService: MenuitemsService)
    {
      // this.internetConnectionCheck();
    }


    
  ngOnInit() {
    this.versionautoupdate();
  }

  versionautoupdate(){
    this.curent_version_number = localStorage.getItem('version_number')
    this.new_version_number = null;
    this.menuitemsService.Getwebappversion().subscribe(data=>{
      this.new_version_number = data[0]['versionnumbers']
      setTimeout(()=>{
      if(this.curent_version_number && this.curent_version_number != 'null' && this.curent_version_number != this.new_version_number){
        localStorage.setItem("version_number",this.new_version_number)
        this.reloadPage();
      }
      else{
				localStorage.setItem("version_number",this.new_version_number)
			}
    }, 200);
    });
  }

  reloadPage(){
    window.location.reload()
  }

  internetConnectionCheck() {
    this.connectionService.monitor().subscribe(isConnected => {
      if (!isConnected) {
        this.router.navigate(['/errors/offline/'])
      }
    });
  }
  scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  @HostListener('window:scroll', [])
onWindowScroll() {
  if (window.pageYOffset > 100) {
    this.showButton = true;
  } else {
    this.showButton = false;
  }
}
}
